import { createBehavior } from '@area17/a17-behaviors';

const accordion = createBehavior(
  'accordion',
  {
    toggleItem($item, shouldOpen) {
      const $content = $item.querySelector('[data-accordion-content]');
      const $contentInner = $content.querySelector(
        '[data-accordion-content-inner]'
      );
      $item.classList.toggle('accordion:is-open', shouldOpen);
      $item.style.setProperty(
        '--accordion-item-content-height',
        $content.scrollHeight + 'px'
      );
      if ($contentInner) {
        if (this.options.duration) {
          if (this.closingTimeouts.get($contentInner)) {
            clearTimeout(this.closingTimeouts.set($contentInner));
          }
        }

        if (shouldOpen) {
          $contentInner.classList.add('accordion:is-visible');
        } else {
          if (this.options.duration) {
            this.closingTimeouts.set(
              $contentInner,
              setTimeout(() => {
                $contentInner.classList.remove('accordion:is-visible');
              }, this.options.duration)
            );
          }
        }
      }
    },
    handleLinkClick(evt) {
      evt.preventDefault();
      const $clickedLink = evt.currentTarget;
      const $clickedItem = $clickedLink.closest('[data-accordion-item]');
      if ($clickedItem.classList.contains('accordion:is-open')) {
        this.toggleItem($clickedItem, false);
      } else {
        this.$items = this.getChildren('item');
        for (const $item of this.$items) {
          this.toggleItem($item, $item === $clickedItem);
        }
      }
    },
  },
  {
    init() {
      this.$items = this.getChildren('item');
      this.$contentInners = this.getChildren('content-inner');
      this.closingTimeouts = new Map();
      this.options.duration = this.options.duration
        ? parseInt(this.options.duration, 10)
        : 0;

      for (const $item of Array.from(this.$items)) {
        const $link = $item.querySelector('[data-accordion-link]');
        $link.addEventListener('click', this.handleLinkClick);
      }

      // content-inner resize observer
      this.contentInnerObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const $content = entry.target.closest('[data-accordion-content]');
          if ($content) {
            $content.style.setProperty(
              '--accordion-item-content-height',
              $content.scrollHeight + 'px'
            );
          }
        }
      });

      if (this.$contentInners) {
        for (const $contentInner of this.$contentInners) {
          this.contentInnerObserver.observe($contentInner);
        }
      }
    },
    destroy() {
      for (const $item of this.$items) {
        const $link = $item.querySelector('[data-accordion-link]');
        $link.removeEventListener('click', this.handleLinkClick);
      }

      if (this.$contentInners) {
        for (const $contentInner of this.$contentInners) {
          this.contentInnerObserver.unobserve($contentInner);
        }
      }
    },
  }
);

export default accordion;
